// 依頁首範圍的組織把 {{leaf}} 設好（lib/leafTerm.ts）；放在 ScopeProvider 裡、所有頁面之前。
import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useScope } from '../lib/scope';
import { treeApi } from '../lib/orgTreeApi';
import { leafKind } from '../lib/leafTerm';
import { setLeafContext } from '../i18n';

export function LeafTermSync() {
  const { i18n } = useTranslation();
  const { org, orgs } = useScope();
  const team = org?.kind === 'team' ? org : null;
  // 同組織樹頁的 query key（['ot', org_id, 'tree-settings']），改名稱後 invalidate 會一起更新
  const settings = useQuery({
    queryKey: ['ot', team?.org_id ?? '', 'tree-settings'],
    queryFn: () => treeApi.settings(team!),
    enabled: !!team,
    staleTime: 60_000,
    retry: false,
  });
  const kind = leafKind(org, orgs);
  const label = team ? (settings.data?.leaf_label ?? null) : null;
  // 先在畫之前設好（子元件這一輪就拿得到），值變了再通知 react-i18next 重畫已經畫過的元件
  const changed = setLeafContext(kind, label);
  useEffect(() => {
    if (changed) i18n.emit('languageChanged', i18n.language);
  }, [changed, i18n, kind, label]);
  return null;
}
